export const languageOptions = [
  {
    label: "Python 3",
    value: "python",
  },
  {
    label: "JavaScript (Node.js)",
    value: "javascript",
  },
  {
    label: "C (GCC)",
    value: "c",
  },
  {
    label: "C++",
    value: "cpp",
  },
];
